import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { GridActionItemType } from '../../../typings/grid';
import { PhrasesSelectorStartPhrasesActions } from '../../../typings/phrases';
import { ActionsMenuDropdown, ActionsMenuDropdownStatus } from '../../ActionsMenuDropdown/ActionsMenuDropdown';

import './PhrasesSelectorToolbox.css';
import * as keyset from './PhrasesSelectorToolbox.i18n';

const i18n = i18nFactory(keyset);

export interface PhrasesSelectorToolboxProps {
    areBulkActionsDisabled: boolean;
    onKeywordsAdd: () => void;
    onRemove: () => void;
}

const BLOCK = 'phrases-selector-toolbox';

const phrasesBulkActions = [
    {
        items: [
            {
                type: GridActionItemType.action,
                text: i18n('add-keywords'),
                val: PhrasesSelectorStartPhrasesActions.addKeywords
            },
            {
                type: GridActionItemType.action,
                text: i18n('remove'),
                val: PhrasesSelectorStartPhrasesActions.remove
            }
        ]
    }
];

export const PhrasesSelectorToolbox = React.memo(
    ({ areBulkActionsDisabled, onKeywordsAdd, onRemove }: PhrasesSelectorToolboxProps) => {
        const actionSelect = (type: GridActionItemType, action: PhrasesSelectorStartPhrasesActions) => {
            const actionsMap = {
                [PhrasesSelectorStartPhrasesActions.addKeywords]: onKeywordsAdd,
                [PhrasesSelectorStartPhrasesActions.remove]: onRemove
            };

            actionsMap[action]();
        };

        return (
            <div className={BLOCK}>
                <ActionsMenuDropdown
                    isCompactViewEnabled={true}
                    status={
                        areBulkActionsDisabled ? ActionsMenuDropdownStatus.disabled : ActionsMenuDropdownStatus.normal
                    }
                    actions={phrasesBulkActions}
                    onActionClick={actionSelect}
                />
            </div>
        );
    }
);
